import { config } from '@/config/config';
import { AuthenticationService, http } from '@singular-health/services';
import Cookies from 'js-cookie';
import type { NavigationGuard } from 'vue-router';
import { beforeRequest } from './beforeRequest';
import { beforeResponse } from './beforeResponse';

http.defaults.baseURL = config.apiUrl;
http.interceptors.request.use(beforeRequest);
http.interceptors.response.use(beforeResponse);

export const viewerBeforeEnter: NavigationGuard = async (to) => {
  const { rt, studyId, collectionId, tenantRegion } = to.query;
  if (!rt) {
    console.error('No refresh token found in query parameters.');
    return { name: 'unauthorized' };
  }

  if (!studyId || !collectionId || !tenantRegion) {
    console.error('Missing required query parameters.', { studyId, collectionId, tenantRegion });
    return { name: 'not-found' };
  }

  try {
    const cookieName = config.cookieName;
    const token = to.query.rt as string;
    const session = await AuthenticationService.refresh(token);
    const value = JSON.stringify(session);
    const options = { path: '/', domain: '.3dicomviewer.com', expires: 365 };
    Cookies.set(cookieName, value, options);
    Cookies.set(cookieName, value, { path: '/', expires: 365 });
  } catch (err) {
    console.error('Failed to refresh session with provided refresh token.', err);
    return { name: 'unauthorized' };
  }
};
